import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, Form, InputNumber, Card, Input, Select, Checkbox, DatePicker, message, Space, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleOutlined, CloseOutlined } from '@ant-design/icons';
import axios from 'axios';
import moment from "moment";
import dayjs from 'dayjs';
import AdminModal from './AdminModal';
import BindLineId from '../../login/BindLineId';
const { Title, Paragraph, Text, Link } = Typography;
const { confirm } = Modal;
const { TextArea } = Input;
// const AdminStudentModal = (
//     editcard,
//     default_editcard = true,
// ) => {
//     const [childrn_editcard, set_children_editcard] = useState(editcard ? editcard : default_editcard);
const AdminStudentModal = (props) => {
    const [form] = Form.useForm();
    const [other, setOther] = useState(false);
    const [modal_img, set_modal_img] = useState(false);
    const [img, setImg] = useState('');
    const [grade_option, set_grade_option] = useState([])
    const [relation, setRelation] = useState([])
    const [fileList, setFileList] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [count, setCount] = useState(0);
    const [gradeClassOption, setGradeClassOption] = useState([])
    useEffect(() => {
        //     if (JSON.stringify(props.editcard) != '{}') {
        //     } else {
        //         // props.setEditCard({ file_id: [], file_url: [] });
        //         setFileList([]);
        //     }
        //     // console.log(student_id != props.editcard.student_id, JSON.stringify(props.editcard) != '{}', JSON.stringify(props.editcard) != '{}')
        //     if (JSON.stringify(props.editcard) != '{}') {
        //         // console.log(123);
        //         setFileList([]);
        //         // get_picture();
        //     }
        if (JSON.stringify(props.editcard) == '{}') {
            props.emergency_contact.push({ key: count });
            setCount(count + 1);
        }
        console.log(props.editcard)
    }, [props.editcard])
    useEffect(() => {
        if (props.editcard.emergency_contact != undefined && props.editcard.emergency_contact.length != 0) {
            let data_tmp = [];
            props.editcard.emergency_contact.map((item, i) => {
                let data_json_tmp = {};
                data_json_tmp['key'] = i;
                data_json_tmp['id'] = item.emergency_contact_id;
                data_json_tmp['emergency_contact_name'] = item.emergency_contact_name;
                data_json_tmp['emergency_contact_phone_number'] = item.emergency_contact_phone_number;
                data_json_tmp['relation_name'] = item.relation_name;
                data_json_tmp['emergency_contact_line_id'] = item.emergency_contact_line_id;
                data_json_tmp['emergency_contact_email'] = item.emergency_contact_email;
                setCount(count + 1);
                data_tmp.push(data_json_tmp);
            })
            props.set_emergency_contact(data_tmp)
        }
    }, [props.editcard.emergency_contact])

    useEffect(() => {
        axios
            .get('/cramSchool/api/grade')
            .then((response) => {
                let data_tmp = [];
                // let data_json_tmp = {};
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['id']
                    data_json_tmp['label'] = value['name'];
                    data_tmp.push(data_json_tmp);
                })
                set_grade_option(data_tmp)
            })
        get_relation();
        getClass()
    }, [])

    const remove_emergency_contact = (i) => {
        props.set_emergency_contact(prev => prev.filter(filter_item => filter_item.key !== i));
    }
    const showDelete = (i) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                remove_emergency_contact(i)
            },
            centered: true
        });
    }
    const get_relation = () => {
        axios
            .get('/cramSchool/api/relation')
            .then((response) => {
                let data_tmp = [];
                // let data_json_tmp = {};
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['relation_id']
                    data_json_tmp['label'] = value['name'];
                    data_tmp.push(data_json_tmp);
                })
                data_tmp.push({ label: '其他', value: '其他' });
                setRelation(data_tmp)
            })
    }
    const getClass = () => {
        axios
            .get('/cramSchool/api/grade_class', {

            })
            .then(response => {
                let data = (response.data?.data) ?? []
                setGradeClassOption((pre) => {
                    return data.map((value) => {
                        return {
                            ...value,
                            label: value?.class_name,
                            value: value?.grade_class_id
                        }
                    })
                })
            })
            .finally((error) => {
            })

    }
    return (<>
        <AdminModal
            {...props}
            title={(<>
                <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 53, left: 32 }} >{props.title}</Col>
            </>)}
            uploads
        >

            <Row gutter={[8, 8]} align={'middle'}>
                {/* <Col span={6}>姓名</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入學生姓名(必填)'} type='text' value={props.editcard.name} name="name" onChange={e => props.setEditCard(pre => ({ ...pre, name: e.target.value }))} />
                </Col>
                <Col span={6}>英文姓名</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入學生英文姓名'} type='text' value={props.editcard.name_english} name="name_english" onChange={e => props.setEditCard(pre => ({ ...pre, name_english: e.target.value }))} />
                </Col>
                <Col span={6}>學號</Col>
                <Col span={18}>
                    {props.edit ? <>
                        <label>{props.editcard['serial_name']}</label>
                    </> :
                        <Space>
                            <Input style={{ width: 180 }} placeholder={'請輸入學生學號(必填)'} type='text' value={props.editcard.serial_name} name="serial_name" onChange={e => props.setEditCard(pre => ({ ...pre, serial_name: e.target.value }))} />
                            <Checkbox onChange={e => props.setEditCard(pre => ({ ...pre, serial_name_make: e.target.checked }))}>自動產生</Checkbox>
                        </Space>
                    }
                </Col>
                <Col span={6}>出生日期</Col>
                <Col span={18}>
                    <DatePicker style={{ width: '100%' }}
                        format={'YYYY-MM-DD'}
                        value={props.editcard.birthday != null ? dayjs(props.editcard.birthday, 'YYYY-MM-DD') : ''}
                        onChange={(value, dateString) => props.setEditCard(preState => {
                            return (
                                {
                                    ...preState,
                                    'birthday': dateString,
                                }
                            )
                        })}
                    />
                </Col>
                <Col span={6}>手機號碼</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入學生手機號碼(必填)'} type='text' value={props.editcard.phone} name="phone" onChange={e => props.setEditCard(pre => ({ ...pre, phone: e.target.value }))} />
                </Col>
                <Col span={6}>家中電話</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入學生家中電話（H）'} type='text' value={props.editcard.phone_home} name="phone_home" onChange={e => props.setEditCard(pre => ({ ...pre, phone_home: e.target.value }))} />
                </Col>
                <Col span={6}>電子信箱</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入學生電子信箱(必填)'} type='email' value={props.editcard.email} name="email" onChange={e => props.setEditCard(pre => ({ ...pre, email: e.target.value }))} />
                </Col> */}
                {/* <Col span={6}>學號</Col>
                <Col span={18}>
                    <Input style={{ width: 180 }} placeholder={'請輸入學生學號(必填)'} type='text' value={props.editcard.std_number} name="std_number" onChange={e => props.setEditCard(pre => ({ ...pre, std_number: e.target.value }))} />
                </Col> */}
                {/* <Col span={6}>學號</Col>
                <Col span={18}>
                    {props.edit ? <>
                        <label>{props.editcard['serial_name']}</label>
                    </> :
                        <Space>
                            <Input style={{ width: 180 }} placeholder={'請輸入學生學號(必填)'} type='text' value={props.editcard.serial_name} name="serial_name" onChange={e => props.setEditCard(pre => ({ ...pre, serial_name: e.target.value }))} />
                            <Checkbox onChange={e => props.setEditCard(pre => ({ ...pre, serial_name_make: e.target.checked }))}>自動產生</Checkbox>
                        </Space>
                    }
                </Col> */}
                <Col span={6}>學號</Col>
                <Col span={18}>
                    <Input style={{ width: 180 }} placeholder={'請輸入學生學號(必填)'} type='text' value={props.editcard.serial_name} name="serial_name" onChange={e => props.setEditCard(pre => ({ ...pre, serial_name: e.target.value }))} />
                </Col>
                <Col span={6}>姓名</Col>
                <Col span={18}>
                    <Input style={{ width: 180 }} placeholder={'請輸入學生姓名(必填)'} type='text' value={props.editcard.name} name="name" onChange={e => props.setEditCard(pre => ({ ...pre, name: e.target.value }))} />
                </Col>
                {/* <Col span={6}>英文姓名</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入學生英文姓名'} type='text' value={props.editcard.name_english} name="name_english" onChange={e => props.setEditCard(pre => ({ ...pre, name_english: e.target.value }))} />
                </Col> */}
                <Col span={6}>性別</Col>
                <Col span={18}>        
                    <Input style={{ width: 180 }} placeholder={'請輸入學生性別(必填)'} type='text' value={props.editcard.grade_name} name="grade_name" onChange={e => props.setEditCard(pre => ({ ...pre, grade_name: e.target.value }))} />  
                </Col>
                <Col span={6}>居住縣市</Col>
                <Col span={18}>        
                    <Input style={{ width: 180 }} placeholder={'請輸入居住縣市(必填)'} type='text' value={props.editcard.birthday} name="birthday" onChange={e => props.setEditCard(pre => ({ ...pre, birthday: e.target.value }))} />  
                </Col>
                <Col span={6}>服務學校</Col>
                <Col span={18}>        
                    <Input style={{ width: 180 }} placeholder={'請輸入服務學校(必填)'} type='text' value={props.editcard.school} name="school" onChange={e => props.setEditCard(pre => ({ ...pre, school: e.target.value }))} />  
                </Col>
                {/* <Col span={6}>出生日期</Col>
                <Col span={18}>
                    <DatePicker style={{ width: '100%' }}
                        format={'YYYY-MM-DD'}
                        value={props.editcard.birthday != null ? dayjs(props.editcard.birthday, 'YYYY-MM-DD') : ''}
                        onChange={(value, dateString) => props.setEditCard(preState => {
                            return (
                                {
                                    ...preState,
                                    'birthday': dateString,
                                }
                            )
                        })}
                    />
                </Col> */}
                <Col span={6}>行動號碼</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入學生手機號碼(必填)'} type='text' value={props.editcard.phone} name="phone" onChange={e => props.setEditCard(pre => ({ ...pre, phone: e.target.value }))} />
                </Col>
                <Col span={6}>任教科目</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入學生任教科目(必填)'} type='text' value={props.editcard.name_english} name="name_english" onChange={e => props.setEditCard(pre => ({ ...pre, name_english: e.target.value }))} />
                </Col>
                <Col span={6}>電子信箱</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入學生電子信箱(必填)'} type='email' value={props.editcard.email} name="email" onChange={e => props.setEditCard(pre => ({ ...pre, email: e.target.value }))} />
                </Col>
                <Col span={6}>聽</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入「B1」或「B2」或「無」'} type='text' value={props.editcard.phone_home} name="phone_home" onChange={e => props.setEditCard(pre => ({ ...pre, phone_home: e.target.value }))} />
                </Col>
                {/* <Col span={6}>說</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入「B1」或「B2」或「無」'} type='text' value={props.editcard.study_time_start} name="study_time_start" onChange={e => props.setEditCard(pre => ({ ...pre, study_time_start: e.target.value }))} />
                </Col> */}
                {/* <Col span={6}>讀</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入「B1」或「B2」或「無」'} type='text' value={props.editcard.study_time_end} name="study_time_end" onChange={e => props.setEditCard(pre => ({ ...pre, study_time_end: e.target.value }))} />
                </Col> */}
                <Col span={6}>說</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入「B1」或「B2」或「無」'} type='text' value={props.editcard.speaking} name="speaking" onChange={e => props.setEditCard(pre => ({ ...pre, speaking: e.target.value }))} />
                </Col>
                <Col span={6}>讀</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入「B1」或「B2」或「無」'} type='text' value={props.editcard.reading} name="reading" onChange={e => props.setEditCard(pre => ({ ...pre, reading: e.target.value }))} />
                </Col>
                <Col span={6}>寫</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入「B1」或「B2」或「無」'} type='text' value={props.editcard.address} name="address" onChange={e => props.setEditCard(pre => ({ ...pre, address: e.target.value }))} />
                </Col>
                <Col span={6}>班別</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入班別'} type='text' value={props.editcard.is_free_tuition} name="is_free_tuition" onChange={e => props.setEditCard(pre => ({ ...pre, is_free_tuition: e.target.value }))} />
                </Col>
                <Col span={6}>Line ID</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入學生Line ID'} type='text' value={props.editcard.line_id} name="line_id" onChange={e => props.setEditCard(pre => ({ ...pre, line_id: e.target.value }))} />
                </Col>
                {/* <Col span={6}>RFID code</Col>
                <Col span={18}>
                    <Input
                        placeholder={'請輸入學生RFID code'}
                        type='text'
                        value={props.editcard.user_external_token_data?.find(find_item => find_item.external_token_type_name === 'rfid')?.user_external_token_token} name="rfid"
                        onChange={(e) => {
                            props.setEditCard((pre) => {
                                let user_external_token_id = (pre.user_external_token_data || [])?.find(find_item => find_item.external_token_type_name === 'rfid')?.user_external_token_id
                                console.log(pre)
                                console.log(user_external_token_id)
                                if (user_external_token_id) {
                                    return {
                                        ...pre,
                                        user_external_token_data: [{
                                            user_external_token_id,
                                            external_token_type_name: 'rfid',
                                            user_external_token_token: e.target.value
                                        }]
                                    }
                                }
                                else {
                                    return {
                                        ...pre,
                                        user_external_token_data: [{
                                            external_token_type_name: 'rfid',
                                            user_external_token_token: e.target.value
                                        }]
                                    }
                                }
                            })
                        }}
                    />
                </Col> */}
                {/* <Col span={6}>當前年級</Col>
                <Col span={18}>
                    <Select
                        style={{
                            width: 250,
                        }}
                        labelInValue
                        value={props.editcard.grade_name}
                        placeholder='請輸入學生當前年級(必填)'
                        name="title"
                        onChange={(value) => {
                            props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        grade_id: value['value'],
                                        grade_name: value['label'],
                                    }
                                )
                            })
                        }}
                        options={grade_option}>
                    </Select>
                </Col>
                <Col span={6}>當前班級</Col>
                <Col span={18}>
                    <Select
                        style={{
                            width: 250,
                        }}
                        // labelInValue
                        value={(props.editcard?.grade_class_student_data || []).map((value) => {
                            return value?.grade_class_id
                        })}
                        placeholder='請輸入學生當前班級(必填)'
                        onChange={(value) => {
                            console.log({ value })
                            let grade_class_id = [value]
                            let grade_class_student_data = gradeClassOption.filter((element) => {
                                return grade_class_id.includes(element?.grade_class_id)
                            })
                            grade_class_student_data = grade_class_student_data.map((value) => {
                                return {
                                    "grade_class_student_id": value?.grade_class_student_id,
                                    "grade_class_id": value?.grade_class_id,
                                    "grade_id": value?.grade_id,
                                    "class_id": value?.class_id,
                                    "class_name": value?.class_name,
                                    "class_name_serial": value?.class_name_serial,
                                }
                            })
                            console.log({ grade_class_student_data })
                            props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        // class_id: [value],
                                        grade_class_student_data: grade_class_student_data
                                    }
                                )
                            })
                        }}
                        options={gradeClassOption}>
                    </Select>
                </Col>
                <Col span={6}>免學費</Col>
                <Col span={18}>
                    <Switch checked={props.editcard.is_free_tuition === 1} onChange={e => props.setEditCard(pre => ({ ...pre, is_free_tuition: e ? 1 : 0 }))} />
                    {props.editcard.is_free_tuition === 1 ? '是' : '否'}
                </Col>
                <Col span={6}>分期期數</Col>
                <Col span={18}>
                    <InputNumber 
                    min = {1}
                    placeholder={'請輸入分期期數'} 
                    type='text' value={props.editcard.installment_count} 
                    name="rfid"
                     onChange={value => props.setEditCard(pre => ({ ...pre, installment_count: value }))} />
                </Col> */}
                {/* <Col span={24}>
                    <Button type='primary' onClick={e => { setCount(count + 1); props.emergency_contact.push({ key: count }) }}>新增緊急聯絡人、聯絡電話</Button>
                </Col> */}
                {/* <Col span={24}> */}
                    {/* <Form
                        labelCol={{
                            span: 6,
                        }}
                        wrapperCol={{
                            span: 18,
                        }}
                        // form={form}
                        // fields={props.emergency_contact}
                        name="dynamic_form_complex"
                        autoComplete="off"
                        initialValues={{
                            items: [{}],
                        }}
                    > */}
                        {/* <Row gutter={[8, 8]}>
                            {props.emergency_contact.map((item, i) => {
                                // if (i != 0) {
                                return (
                                    <>
                                        <Col span={24}>
                                            <Card
                                                size="small"
                                                title={`緊急聯絡人 ${i + 1}`}
                                                key={item.key}
                                                extra={
                                                    <CloseOutlined
                                                        onClick={() => {
                                                            showDelete(item.key)
                                                        }}
                                                    />
                                                }
                                            >
                                                <Form.Item label="姓名" >
                                                    <Input placeholder={'請輸入緊急連絡人'} type='text'
                                                        value={item.emergency_contact_name}
                                                        // name="emergency_contact"
                                                        onChange={e =>
                                                            props.set_emergency_contact(pre => {
                                                                return (
                                                                    pre.map((value) => {
                                                                        if (value.key == item.key) {
                                                                            return (
                                                                                {
                                                                                    ...value,
                                                                                    emergency_contact_name: e.target.value
                                                                                }
                                                                            )
                                                                        } else {
                                                                            return ({ ...value })
                                                                        }
                                                                    })
                                                                )
                                                            })
                                                        }
                                                    />
                                                </Form.Item> */}
                                                {/* <Form.Item label="電話" >
                                                    <Input placeholder={'請輸入緊急連絡人電話'}
                                                        type='text'
                                                        value={item.emergency_contact_phone_number}
                                                        // name="emergency_phone" 
                                                        onChange={e =>
                                                            props.set_emergency_contact(pre => {
                                                                return (
                                                                    pre.map((value) => {
                                                                        if (value.key == item.key) {
                                                                            return (
                                                                                {
                                                                                    ...value,
                                                                                    emergency_contact_phone_number: e.target.value
                                                                                }
                                                                            )
                                                                        } else {
                                                                            return ({ ...value })

                                                                        }
                                                                    })
                                                                )
                                                            })
                                                        }
                                                    />
                                                </Form.Item> */}
                                                {/* <Form.Item label="關係" >
                                                    <Select placeholder={'請輸入與緊急連絡人的關係'}
                                                        value={item.relation_id == '其他' ? '其他' : item.relation_name}
                                                        // name="emergency_phone" 
                                                        options={relation}
                                                        labelInValue
                                                        onChange={value => {
                                                            if (value.value == null) {
                                                                setOther(true);
                                                            } else {
                                                                setOther(false);
                                                                props.set_emergency_contact(pre => {
                                                                    return (
                                                                        pre.map((values) => {
                                                                            if (values.key == item.key) {
                                                                                return (
                                                                                    {
                                                                                        ...values,
                                                                                        relation_name: value['label'],
                                                                                        relation_id: value['value']
                                                                                    }
                                                                                )
                                                                            } else {
                                                                                return ({ ...values })

                                                                            }
                                                                        })
                                                                    )
                                                                })
                                                            }
                                                        }}
                                                    />
                                                </Form.Item> */}
                                                {/* {item.relation_id == '其他' &&
                                                    <Form.Item label="填寫關係" >
                                                        <Input placeholder={'請輸入與緊急連絡人的關係'}
                                                            value={item.relation_name}
                                                            // name="emergency_phone" 
                                                            options={relation}
                                                            labelInValue
                                                            onChange={e => {
                                                                props.set_emergency_contact(pre => {
                                                                    return (
                                                                        pre.map((values) => {
                                                                            if (values.key == item.key) {
                                                                                return (
                                                                                    {
                                                                                        ...values,
                                                                                        relation_name: e.target.value
                                                                                    }
                                                                                )
                                                                            } else {
                                                                                return ({ ...values })

                                                                            }
                                                                        })
                                                                    )
                                                                })
                                                            }}
                                                        />
                                                    </Form.Item>
                                                } */}
                                                {/* <Form.Item label="Line ID" >
                                                    <Input placeholder={'請輸入與緊急連絡人的Line ID'}
                                                        type='text'
                                                        value={item.emergency_contact_line_id}
                                                        // name="emergency_phone" 
                                                        onChange={e =>
                                                            props.set_emergency_contact(pre => {
                                                                return (
                                                                    pre.map((value) => {
                                                                        if (value.key == item.key) {
                                                                            return (
                                                                                {
                                                                                    ...value,
                                                                                    emergency_contact_line_id: e.target.value
                                                                                }
                                                                            )
                                                                        } else {
                                                                            return ({ ...value })

                                                                        }
                                                                    })
                                                                )
                                                            })
                                                        }
                                                    />
                                                </Form.Item> */}
                                                {/* <Form.Item label="信箱" >
                                                    <Input placeholder={'請輸入與緊急連絡人的信箱'}
                                                        type='text'
                                                        value={item.emergency_contact_email}
                                                        // name="emergency_phone" 
                                                        onChange={e =>
                                                            props.set_emergency_contact(pre => {
                                                                return (
                                                                    pre.map((value) => {
                                                                        if (value.key == item.key) {
                                                                            return (
                                                                                {
                                                                                    ...value,
                                                                                    emergency_contact_email: e.target.value
                                                                                }
                                                                            )
                                                                        } else {
                                                                            return ({ ...value })

                                                                        }
                                                                    })
                                                                )
                                                            })
                                                        }
                                                    />
                                                </Form.Item>
                                            </Card>
                                        </Col>
                                    </>
                                )

                            })} */}
                            {/* <Col span={24}>
                                <Button type='primary' onClick={e => { setCount(count + 1); props.emergency_contact.push({ key: count }) }} block>
                                    + 新增緊急聯絡人、聯絡電話、關係、Line ID、信箱
                                </Button>
                            </Col> */}
                        {/* </Row> */}

                        {/* </div>
                            )}
                        </Form.List> */}
                    {/* </Form> */}
                {/* </Col> */}
                {/* <Col span={6}>學校</Col>
                <Col span={18}>
                    <Input placeholder={'請輸入學校'} type='text' value={props.editcard.school} name="school" onChange={e => props.setEditCard(pre => ({ ...pre, school: e.target.value }))} />
                </Col>
                <Col span={9}>學生就學時間（起）</Col>
                <Col span={15}>
                    <DatePicker style={{ width: '100%' }}
                        value={props.editcard.study_time_start != null ? dayjs(props.editcard.study_time_start, 'YYYY-MM-DD') : ''}
                        format={'YYYY-MM-DD'}
                        onChange={(value, dateString) => props.setEditCard(preState => {
                            return (
                                {
                                    ...preState,
                                    'study_time_start': dateString,
                                }
                            )
                        })}
                    />
                </Col>
                <Col span={9} style={{ whiteSpace: 'nowrap' }}>學生就學時間（迄）</Col>
                <Col span={15}>
                    <DatePicker style={{ width: '100%' }}
                        format={'YYYY-MM-DD'}
                        value={props.editcard.study_time_end != null ? dayjs(props.editcard.study_time_end, 'YYYY-MM-DD') : ''}
                        onChange={(value, dateString) => props.setEditCard(preState => {
                            return (
                                {
                                    ...preState,
                                    'study_time_end': dateString,
                                }
                            )
                        })}
                    />
                </Col>
                <Col span={6}>地址</Col> */}
                {/* <Col span={18}>
                    <Input placeholder={'請輸入學生地址'} type='text' value={props.editcard.address} name="address" onChange={e => props.setEditCard(pre => ({ ...pre, address: e.target.value }))} />
                </Col> */}
                <Col span={6}>備註</Col>
                <Col span={18}><Input.TextArea onChange={e => props.setEditCard(pre => ({ ...pre, note: e.target.value }))} />
                </Col>
            </Row>
        </AdminModal >
    </>)

}
export default AdminStudentModal;